import { DropdownVATOptions } from './enums.ts';
import type {CurrencyEnum, Unit} from '../generated/enums.ts';

export const CATALOG_UNIT_LABELS: Record<Unit, string> = {
    hour: 'per uur',
    day: 'per dag',
    piece: 'per stuk',
    project: 'per project',
    month: 'per maand',
    km: 'per km',
} as const;

export const CATALOG_UNIT_OPTIONS: Array<{ value: Unit; label: string }> =
    (Object.entries(CATALOG_UNIT_LABELS) as Array<[Unit, string]>).map(
        ([value, label]) => ({ value, label }),
    );

export interface CatalogItem {
    id: string;
    name: string;
    unit_price_cents: number;
    currency: CurrencyEnum;
    vat_option: DropdownVATOptions;
    unit: Unit;
    times_used: number;
    archived_at: string | null;
    created_at: string;
    updated_at: string;
}

export const VAT_SHORT_LABELS: Record<DropdownVATOptions, string> = {
    [DropdownVATOptions.STANDARD]: '21%',
    [DropdownVATOptions.REDUCED]: '9%',
    [DropdownVATOptions.EXEMPT]: 'Vrijgesteld',
    [DropdownVATOptions.REVERSE_CHARGE]: 'Verlegd',
    [DropdownVATOptions.ZERO]: '0%',
} as const;
